import classnames from "classnames";
import { FormText, InputGroup, InputGroupText } from "reactstrap";
import { InputWrapper } from "./InputWrapper";

export const PercentInput = ({ children, input, label, meta, ...rest }) => {
  return (
    <InputWrapper label={label} required={rest.required}>
      <InputGroup>
        <input
          {...input}
          type="number"
          inputMode="numeric"
          pattern="\d*"
          className={classnames("form-control", rest.className, {
            "is-invalid": Boolean(meta.touched && meta.error),
          })}
          {...rest}
        />
        <InputGroupText>%</InputGroupText>
      </InputGroup>
      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}
      {children}
    </InputWrapper>
  );
};
